import script from "./GlobalButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./GlobalButtonPrimary.vue?vue&type=style&index=0&id=3e26e30e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e26e30e"]])

export default __exports__